import type { RouteRecordRaw } from 'vue-router'
import { VideoPlayIcon } from '@/components/icons'
import { getRootRedirect } from './root-redirect'

export const CourseRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'courses',
    redirect: (to) => getRootRedirect(to.query),
    meta: { middleware: 'auth', requiresAuth: true },
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    children: [
      {
        path: '/home',
        name: 'learning-home',
        component: () => import('@/views/learning-home/index.vue'),
        meta: { title: 'خانه' }
      },
      {
        path: '/home/languages',
        name: 'home-languages',
        component: () => import('@/views/learning-home/languages.vue'),
        meta: { title: 'دوره‌ها' }
      },
      {
        path: '/home/languages/:languageId',
        name: 'home-language-courses',
        component: () => import('@/views/learning-home/language-courses.vue'),
        props: true,
        meta: { title: 'دوره‌ها' }
      },
      {
        path: '/courses',
        name: 'course-list',
        component: () => import('@/views/course-lessons/courses/index.vue'),
        meta: {
          title: 'دوره‌ها',
          breadcrumb: [{ text: 'دوره ها', to: '/courses', icon: VideoPlayIcon }]
        }
      },
      {
        path: '/courses/ielts-program/placement/:classId',
        name: 'class-placement-exam',
        component: () => import('@/views/course-lessons/class-placement-exam/index.vue'),
        meta: { title: 'آزمون تعیین سطح آیلتس' },
        props: (route) => ({ classId: route.params.classId })
      },
      {
        path: '/courses/ielts-learning-path',
        name: 'ielts-learning-path',
        component: () => import('@/views/course-lessons/ielts-learning-path/index.vue'),
        meta: { title: 'معرفی کلاس آنلاین آیلتس' },
        props: (route) => ({
          classId: typeof route.query.classId === 'string' ? route.query.classId : undefined
        })
      },
      {
        path: '/courses/ielts-program/recordings',
        name: 'ielts-program-recordings',
        component: () => import('@/views/course-lessons/ielts-recordings/index.vue'),
        meta: { title: 'جلسات ضبط‌شده آیلتس' },
        props: (route) => ({
          classId: typeof route.query.classId === 'string' ? route.query.classId : undefined,
          sessionId: typeof route.query.sessionId === 'string' ? route.query.sessionId : undefined
        })
      },
      {
        path: '/courses/ielts-program/recordings/:recordingId',
        name: 'ielts-program-recording-detail',
        component: () => import('@/views/course-lessons/ielts-recordings/lesson.vue'),
        meta: { title: 'مشاهده جلسه ضبط‌شده' },
        props: (route) => ({
          recordingId: route.params.recordingId,
          classId: typeof route.query.classId === 'string' ? route.query.classId : undefined
        })
      },
      {
        path: '/ielts/placement/result',
        name: 'ielts-placement-result',
        component: () => import('@/views/placement/placement-result.vue'),
        meta: { title: 'نتیجه تعیین سطح آیلتس' }
      },
      {
        path: '/courses/:course_id',
        name: 'course_detail',
        component: () => import('@/views/course-lessons/courses/course/index.vue'),
        props: (route) => ({ course_id: route.params.course_id })
      },
      {
        path: '/courses/:course_id/roadmap',
        name: 'course_roadmap',
        component: () => import('@/views/course-lessons/roadmap/index.vue'),
        meta: { requiresPlanAccess: true }
      },
      {
        path: '/courses/:course_id/leaderboard',
        name: 'course_leaderboard',
        component: () => import('@/views/course-lessons/leaderboard/index.vue'),
        meta: {
          requiresPlanAccess: true,
          breadcrumb: [{ text: 'لیدربورد', to: '/', icon: VideoPlayIcon }]
        }
      },
      {
        path: 'lessons/:courseId/discussion/:sectionId',
        name: 'course_discussion',
        component: () => import('@/views/course-lessons/discussions.vue'),
        meta: { requiresPlanAccess: true }
      }
    ]
  },
  {
    path: '/courses/ielts-program',
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    meta: { middleware: 'auth', requiresAuth: true },
    children: [
      {
        path: '',
        name: 'ielts-program',
        component: () => import('@/views/course-lessons/ielts-program/index.vue'),
        meta: { title: 'کلاس آنلاین آیلتس' },
        props: (route) => ({
          classId: typeof route.query.classId === 'string' ? route.query.classId : undefined
        })
      }
    ]
  },
  {
    path: '/ielts',
    name: 'ielts-entry',
    component: () => import('@/views/course-lessons/ielts-program/entry.vue'),
    meta: { middleware: 'auth', requiresAuth: true, title: 'کلاس آنلاین آیلتس' }
  },
  {
    path: '/courses/ielts-program/live',
    name: 'ielts-program-live',
    component: () => import('@/views/course-lessons/ielts-live-class/index.vue'),
    props: (route) => ({
      classId: typeof route.query.classId === 'string' ? route.query.classId : undefined,
      sessionId: typeof route.query.sessionId === 'string' ? route.query.sessionId : undefined
    }),
    meta: { middleware: 'auth', requiresAuth: true, title: 'کلاس زنده آیلتس' }
  }
]
